<template>
  <li
    class="block px-4 py-2 hover:bg-muted-100 dark:hover:bg-muted-600 transition-colors dark:hover:text-white !mb-0 cursor-pointer border-b last:border-0 border-muted-300 dark:border-muted-600"
    v-on="$listeners"
  >
    <slot />
  </li>
</template>

<script>
export default {
  name: 'DropdownItemComponent'
};
</script>

<style lang="scss" scoped>

</style>
